import { Component, Story, Knobs, Accents } from './DocTypes';

const TextEditorsKnobs: Knobs = {
  label: {
    default: 'Enter some text',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  labelPosition: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'top', 'left'],
    delimiter: '\n  ',
  },
  placeholder: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  editor: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'textbox', 'multilinetextbox', 'password', 'email'],
    delimiter: '\n  ',
  },
  inline: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  maxLength: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  autocomplete: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'on', 'off'],
    delimiter: '\n  ',
  },
  rows: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', '1', '2', '3', '4', '5'],
    delimiter: '\n  ',
  },
};
const TextEditorsStory: Story = {
  title: 'Text editors',
  description: 'A playground for text editors',
  coreComponent: {
    html: `<tag-edit-field{{...knobs}}>
</tag-edit-field>`,
    knobs: TextEditorsKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField{{...knobs}}
/>`,
    knobs: TextEditorsKnobs,
  },
};

const NumericEditorsKnobs: Knobs = {
  label: {
    default: 'Enter a number',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  labelPosition: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'top', 'left'],
    delimiter: '\n  ',
  },
  placeholder: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  editor: {
    default: 'number',
    editor: 'dropdown',
    editorOptions: ['number', 'slider'],
    delimiter: '\n  ',
  },
  dataType: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'integer', 'decimal', 'currency'],
    delimiter: '\n  ',
  },
  inline: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  min: {
    default: '',
    editor: 'number',
    delimiter: '\n  ',
  },
  max: {
    default: '',
    editor: 'number',
    delimiter: '\n  ',
  },
  step: {
    default: '',
    editor: 'number',
    delimiter: '\n  ',
  },
};
const NumericEditorsStory: Story = {
  title: 'Numeric editors',
  description: 'A playground for numeric editors',
  coreComponent: {
    html: `<tag-edit-field{{...knobs}}>
</tag-edit-field>`,
    knobs: NumericEditorsKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField{{...knobs}}
/>`,
    knobs: NumericEditorsKnobs,
  },
};

const DateEditorKnobs: Knobs = {
  label: {
    default: 'Enter a date',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  labelPosition: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'top', 'left'],
    delimiter: '\n  ',
  },
  placeholder: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  dataType: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'date', 'datetime'],
    delimiter: '\n  ',
  },
  inline: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  clearButton: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
};
const DateEditorStory: Story = {
  title: 'Date editor',
  description: 'A playground for the date editor',
  coreComponent: {
    html: `<tag-edit-field
  editor='datepick'{{...knobs}}>
</tag-edit-field>`,
    knobs: DateEditorKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField
  editor='datepick'{{...knobs}}
/>`,
    knobs: DateEditorKnobs,
  },
};

const CheckboxEditorKnobs: Knobs = {
  label: {
    default: 'Is it?',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  accent: {
    default: false,
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n  ',
  },
  rounded: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  size: {
    default: false,
    editor: 'dropdown',
    editorOptions: ['', 'Normal', 'Large'],
    delimiter: '\n  ',
  },
};
const CheckboxEditorStory: Story = {
  title: 'Checkbox editor',
  description: 'A playground for the checkbox editor',
  coreComponent: {
    html: `<tag-edit-field
  editor='checkbox'{{...knobs}}>
</tag-edit-field>`,
    knobs: CheckboxEditorKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField
  editor='checkbox'{{...knobs}}
/>`,
    knobs: CheckboxEditorKnobs,
  },
};

const SelectEditorsKnobs: Knobs = {
  label: {
    default: 'Urgency',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  labelPosition: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'top', 'left'],
    delimiter: '\n  ',
  },
  placeholder: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  editor: {
    default: 'dropdown',
    editor: 'dropdown',
    editorOptions: ['dropdown', 'combobox', 'radio', 'toggle'],
    delimiter: '\n  ',
  },
  inline: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  clearButton: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  searchable: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
};
const SelectEditorsStory: Story = {
  title: 'Select editors',
  description: 'A playground for select editors',
  coreComponent: {
    html: `<tag-edit-field{{...knobs}}>
  <tag-edit-field-option value=''></tag-edit-field-option>
  <tag-edit-field-option value='1'>High</tag-edit-field-option>
  <tag-edit-field-option value='2'>Medium</tag-edit-field-option>
  <tag-edit-field-option value='3'>Low</tag-edit-field-option>
</tag-edit-field>`,
    knobs: SelectEditorsKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField{{...knobs}}
  options={[
    {label: '', value: ''},
    {label: 'High', value: 1},
    {label: 'Medium', value: 2},
    {label: 'Low', value: 3}
  ]}
/>`,
    knobs: SelectEditorsKnobs,
  },
};

const FileEditorKnobs: Knobs = {
  label: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  accept: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
};
const FileEditorStory: Story = {
  title: 'File editor',
  description: 'A playground for the file editor',
  coreComponent: {
    html: `<tag-edit-field
  editor='filepick'{{...knobs}}>
</tag-edit-field>`,
    knobs: FileEditorKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField
  editor='filepick'{{...knobs}}
/>`,
    knobs: FileEditorKnobs,
  },
};

const CustomEditorStory: Story = {
  title: 'Custom editor',
  description: 'A custom editor',

  reactWrapper: {
    jsx: `<Example />`,
    knobs: FileEditorKnobs,
    parentJSX: `Example = () => {
    const [time, setTime] = React.useState(undefined);

    return (
      <TagEditField
        label="Enter the time"
        value={time}
        onValueChange={e => {
          console.log(e);
          setTime(e.detail.value);
        }}
        renderEditor={({onValueChange, onBlur}) =>
          <input
            type="time"
            value={time}
            onChange={e => onValueChange({value: e.currentTarget.value})}
            onBlur={onBlur}
          />
        }
        validation={[{ rule: 'required' }]}
      />
    )
  };
  `,
  },
};

const FormattingKnobs: Knobs = {
  label: {
    default: 'Amount',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '53.13',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  dataType: {
    default: 'decimal',
    editor: 'dropdown',
    editorOptions: ['integer', 'decimal', 'currency'],
    delimiter: '\n  ',
  },
  formattingOptions: {
    default: '{"style": "currency", "currency": "EUR"}',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  inline: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  disabled: {
    default: true,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
};
const FormattingStory: Story = {
  title: 'Formatting',
  description: 'Numeric formatting for disabled fields',
  coreComponent: {
    html: `<tag-edit-field
  {{...knobs}}>
</tag-edit-field>`,
    knobs: FormattingKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField
  {{...knobs}}
/>`,
    knobs: FormattingKnobs,
  },
};

const FormattingModeKnobs: Knobs = {
  label: {
    default: 'Amount',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '53.13',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  dataType: {
    default: 'decimal',
    editor: 'dropdown',
    editorOptions: ['integer', 'decimal', 'currency'],
    delimiter: '\n  ',
  },
  formattingOptions: {
    default: '{"style": "currency", "currency": "EUR"}',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  inline: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  selectTextWhenFocused: {
    default: true,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  applyFormattingMode: {
    default: 'blur',
    editor: 'dropdown',
    editorOptions: ['disabled', 'blur'],
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
};

const FormattingModeStory: Story = {
  title: 'Formatting Mode',
  description: 'Enable formatting for disabled / onblur',
  coreComponent: {
    html: `<tag-edit-field
  {{...knobs}}>
</tag-edit-field>`,
    knobs: FormattingModeKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField
  {{...knobs}}
/>`,
    knobs: FormattingModeKnobs,
  },
};

const FocusKnobs: Knobs = {
  editor: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'textbox', 'multilinetextbox', 'password', 'email'],
  },
};
const FocusStory: Story = {
  title: 'Focus',
  description: 'How to set focus to fields and select their content',
  coreComponent: {
    html: `<div style="display: flex;">
  <tag-edit-field{{...knobs}}>
  </tag-edit-field>
  <tag-button text="Set focus to editor" class='focus'></tag-button>
  <tag-button text="Select editor text" class='select'></tag-button>
</div>`,
    js: `var editor = document.querySelector("tag-edit-field");
document.querySelector(".focus").addEventListener("buttonClick", function () {
  editor.focusEditor();
});
document.querySelector(".select").addEventListener("buttonClick", function () {
  editor.selectEditorText();
});`,
    knobs: FocusKnobs,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const editor = React.useRef(null);
    const select = React.useRef(null);
    const focus = React.useRef(null);
    React.useEffect(() => {
      focus.current.tagComponent.current.addEventListener("buttonClick", function () {
        editor.current.tagComponent.current.focusEditor();
      });
      select.current.tagComponent.current.addEventListener("buttonClick", function () {
        editor.current.tagComponent.current.selectEditorText();
      });
    }, [])
    return (
      <div style={{display: 'flex'}}>
        <TagEditField ref={editor}
        {{...knobs}} />
        <TagButton ref={focus} text='Set focus to editor'/>
        <TagButton ref={select} text='Select editor text'/>
      </div>
      )
  }`,
    knobs: FocusKnobs,
  },
};

const ValidationKnobs: Knobs = {
  displayValidationMessage: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'flow', 'overlay'],
  },
};
const ValidationStory: Story = {
  title: 'Validation',
  description: 'Playground for validation configuration',
  coreComponent: {
    html: `<tag-edit-field{{...knobs}}>
    <tag-validation rule='required'></tag-validation>
  </tag-edit-field>`,
    knobs: ValidationKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField
  validation={[
    {rule: "required"}
  ]}{{...knobs}}
/>`,
    knobs: ValidationKnobs,
  },
};

const CancelChangeKnobs: Knobs = {
  label: {
    default: 'An editor with only numeric input',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '100.00',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  editor: {
    default: 'textbox',
    editor: 'dropdown',
    editorOptions: ['checkbox', 'textbox'],
    delimiter: '\n  ',
  },
  dataType: {
    default: 'decimal',
    editor: 'dropdown',
    editorOptions: ['integer', 'decimal', 'currency'],
    delimiter: '\n  ',
  },
  selectTextWhenFocused: {
    default: 'true',
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  formattingOptions: {
    default: '{"style": "currency", "currency": "EUR"}',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  applyFormattingMode: {
    default: 'blur',
    editor: 'dropdown',
    editorOptions: ['disabled', 'blur'],
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
};

const CancelKeypress: Story = {
  title: 'Suppress keystrokes',
  description: 'An example of suppressing keystrokes',
  coreComponent: {
    html: `<tag-edit-field {{...knobs}}>
</tag-edit-field>`,
    js: `
  var tagEditField = document.querySelector('tag-edit-field');
  tagEditField.componentOnReady().then(function() {
    tagEditField.addEventListener("editorKeypress", (e) => {
      const valid = e.detail.key === 'Backspace' || e.detail.key === '.' || isFinite(e.detail.key);
      e.detail.cancel = !valid;
    });
  });`,
    knobs: CancelChangeKnobs,
  },
  reactWrapper: {
    jsx: `<TagEditField onEditorKeypress={e => {
    const valid = e.detail.key === 'Backspace' || e.detail.key === '.' || isFinite(e.detail.key);
    e.detail.cancel = !valid;
  }} {{...knobs}}/>`,
    knobs: CancelChangeKnobs,
  },
};

export const TagEditFieldDocs: Component = {
  type: 'component',
  name: 'edit-field',
  description: 'Renders a label and field editor',
  mobileFriendly: false,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The name of the field that is used when the posted via tag-form',
      type: 'string',
    },
    {
      name: 'id',
      description:
        'The id to be place on the input. This will tie the label to the input so that a screen reader can read it correctly. This should not be used on workspace apps because workspace apps does not support ids',
      type: 'string',
    },
    {
      name: 'label',
      description: 'The field label',
      type: 'string',
    },
    {
      name: 'dataType',
      description: 'The type of the field that is used for value conversion',
      type:
        'string | integer | decimal | currency | date | datetime | boolean | image | email | phonenumber',
    },
    {
      name: 'editor',
      description: 'The field editor',
      type:
        'textbox | multilinetextbox | password | email | number | dropdown | combobox | datepick | checkbox | slider | radio | toggle | hidden | filepick ',
      default: 'textbox',
    },
    {
      name: 'containerStyle',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'labelStyle',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'editorStyle',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'placeholder',
      description: 'The placeholder text',
      type: 'string',
    },
    {
      name: 'rows',
      description: 'The number of rows for a MultilineTextbox',
      type: 'string',
    },
    {
      name: 'min',
      description: 'The minimum value',
      type: 'number',
    },
    {
      name: 'max',
      description: 'The maximum value',
      type: 'number',
    },
    {
      name: 'step',
      description: 'The increment value when using the keyboard arrow buttons',
      type: 'number',
    },
    {
      name: 'defaultValue',
      description: 'The default value',
      type: 'any',
    },
    {
      name: 'allowSubmitOnReturn',
      description: 'Whether the field should submit the form if return is pressed',
      type: 'boolean',
    },
    {
      name: 'value',
      description: 'The field value',
      type: 'any',
    },
    {
      name: 'disabled',
      description: 'Whether the editor is disabled',
      type: 'boolean',
    },
    {
      name: 'inline',
      description: 'Whether the label is on the same line as the editor',
      type: 'boolean',
    },
    {
      name: 'formattingOptions',
      description:
        "Additional formatting options for numbers when the field is disabled. This maps directly to the options parameter in Intl.NumberFormat see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat. If editor is set to 'Datepick' then this would map to the options parameter in Intl.DateTimeFormat: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat",
      type: 'string',
    },
    {
      name: 'maxLength',
      description: 'Sets the max-length on editor fields',
      type: 'number',
    },
    {
      name: 'labelPosition',
      description: 'The position of the label',
      type: 'top | left',
    },
    {
      name: 'searchable',
      description:
        'This defines whether the contents are searchable. Supported in the combobox field',
      type: 'boolean',
    },
    {
      name: 'accent',
      description: 'The accent to be passed down to the inner component',
      type: 'string',
    },
    {
      name: 'rounded',
      description: 'The rounded attribute to be passed down to the inner component',
      type: 'boolean',
    },
    {
      name: 'size',
      description: 'The size attribute to be passed down to the inner component',
      type: 'normal | large',
    },
    {
      name: 'clearButton',
      description: 'When suppressed will hide the clear button (disabled by default)',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'autocomplete',
      description: 'Whether or not an input field should have autocomplete enabled',
      type: 'on | off',
      default: 'false',
    },
    {
      name: 'accept',
      description:
        'Specifies the types of files that the server accepts. Only applies to the Filepick editor',
      type: 'string',
    },
    {
      name: 'displayValidationMessage',
      description: 'Specifies the place validations are displayed',
      type: 'flow | overlay',
      default: 'flow',
    },
    {
      name: 'validationMaxWidth',
      description: 'Specifies the validation popover max width',
      type: 'number',
    },
    {
      name: 'validationMinWidth',
      description: 'Specifies the validation popover min width',
      type: 'number',
    },
    {
      name: 'validationAutoSize',
      description: 'Specifies whether the popover autosizes to the width of the input control',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'selectTextWhenFocused',
      description: 'If defined will select the editor text when focused',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'applyFormattingMode',
      description: 'Defines how formatting is displayed within an editor. Disabled only or on blur',
      type: 'disabled | blur',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'valueChange',
      description: 'Triggers when the field value changes',
      parameters: [
        {
          name: 'name',
          description: 'The field name',
          type: 'string',
        },
        {
          name: 'rawValue',
          description: 'The unconverted field value',
          type: 'any',
        },
        {
          name: 'value',
          description: 'The converted field value',
          type: 'any',
        },
        {
          name: 'listIndex',
          description: 'If the field is in a tag-list, this is the list item index',
          type: 'number',
        },
        {
          name: 'cancel',
          description: 'If set to true the valueChange will be cancelled',
          type: 'boolean',
          default: 'false',
        },
      ],
    },
    {
      name: 'validated',
      description: 'Triggers when a field has been validated',
      parameters: [
        {
          name: 'name',
          description: 'The field name',
          type: 'string',
        },
        {
          name: 'errors',
          description: 'The validation errors',
          type: 'string[]',
        },
      ],
    },
    {
      name: 'editorKeypress',
      description: 'Triggers when a keypress event occurs within an editor',
      parameters: [
        {
          name: 'key',
          description: 'The key',
          type: 'string',
        },
        {
          name: 'keyCode',
          description: 'The key code',
          type: 'number',
        },
        {
          name: 'cancel',
          description: 'Defines whether to cancel a keystoke',
          type: 'boolean',
          default: 'false',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'setErrors',
      description: 'Allows field validation errors to be set',
      parameters: [
        {
          name: 'errors',
          description: 'The validation errors',
          type: 'string[]',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'validate',
      description: 'Triggers the validation rules to be invoked on the field',
      parameters: [],
      returnType: 'string[]',
    },
    {
      name: 'validateFieldRemote',
      description: 'Triggers the remote validation rules to be invoked on the field',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'getValue',
      description: 'Returns the value of the edit-field',
      parameters: [],
      returnType: 'any',
    },
    {
      name: 'setValue',
      description: 'Sets the field value',
      parameters: [
        {
          name: 'value',
          description: 'The value to set',
          type: 'any',
        },
        {
          name: 'suppressValidation',
          description: 'Whether to suppress validation when the field value is set',
          type: 'boolean',
        },
        {
          name: 'suppressChangeEvent',
          description: 'Whether to suppress the change event when the field value is set',
          type: 'boolean',
        },
        {
          name: 'suppressConversion',
          description: 'Whether to suppress value conversion when the field value is set',
          type: 'boolean',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'focusEditor',
      description: 'Sets the focus to the editor',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'selectEditorText',
      description: 'Selects the editor text',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'setData',
      description:
        'Sets the data for the field items if the editor is dropdown, combobox, toggle or radio',
      parameters: [
        {
          name: 'data',
          description: 'The data that sets the field items',
          type: 'any',
        },
      ],
      returnType: 'void',
    },
  ],
  stories: [
    TextEditorsStory,
    NumericEditorsStory,
    DateEditorStory,
    CheckboxEditorStory,
    SelectEditorsStory,
    FileEditorStory,
    CustomEditorStory,
    FormattingStory,
    FormattingModeStory,
    FocusStory,
    ValidationStory,
    CancelKeypress,
  ],
};
